import React, { useState } from "react";
import "./muiCheckbox.scss";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@mui/material";

const MuiCheckbox = ({
  checkboxes,
  boxLabel,
  onChange,
  value,
  defaultValue,
  defaultChecked,
}) => {
  const insertMaterialNoInsertId = 31;
  const insertMaterialBoxLabel = "Insert Material";
  const revoFitBoxLabel = "RevoFit®";
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheckboxChange = (label) => {
    if (boxLabel === insertMaterialBoxLabel) {
      let newValues = {}
      if (label === insertMaterialNoInsertId && checkedItems[insertMaterialNoInsertId] === false) {
        checkboxes.forEach(checkout => {
          newValues[checkout.id] = false
        })
        newValues[parseInt(label)] = true;
      } else {
        newValues[insertMaterialNoInsertId] = false;
        newValues[parseInt(label)] = !checkedItems[parseInt(label)];
      }
      defaultValue = newValues
      setCheckedItems((prevState) => ({
        ...prevState,
        ...defaultValue,
      }));
    } else {
      setCheckedItems((prevState) => ({
        ...prevState,
        [label]: !prevState[label],
      }));
    }
  };

  if (boxLabel === insertMaterialBoxLabel) {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label">{boxLabel}</FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id, e);
                  }}
                  checked={
                    checkedItems[checkbox.id] ??
                    defaultValue?.[checkbox.id] ??
                    defaultChecked ??
                    false
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  } else {
    return (
      <div className="muiCheckbox">
        <FormLabel id="demo-radio-buttons-group-label">{boxLabel}</FormLabel>
        <FormGroup row>
          {checkboxes.map((checkbox, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  onChange={(e) => {
                    onChange(e, checkbox.id);
                    handleCheckboxChange(checkbox.id);
                  }}
                  defaultChecked={
                    defaultValue
                      ? defaultValue?.[checkbox?.id]
                      : defaultChecked
                        ? defaultChecked
                        : null
                  }
                  value={value}
                />
              }
              label={
                <div>
                  {checkbox.displayName}
                  {checkbox.desc && <p className="boxDesc">{checkbox.suffix}</p>}
                </div>
              }
              className={
                checkedItems?.[checkbox?.id]
                  ? "checkedLabel"
                  : defaultValue?.[checkbox?.id]
                    ? "checkedLabel"
                    : defaultChecked
                      ? "checkedLabel"
                      : ""
              }
            />
          ))}
        </FormGroup>
      </div>
    );
  }
};

export default MuiCheckbox;
